module.exports = __webpack_public_path__ + "media/success.551da1c8.ogg";